import React from 'react';

const Backdrop2 = (props) => (
    <div className ="backdrop2" onClick={props.click}/>
)

export default Backdrop2;